import { useState } from 'react';
import { cx, ErrorNote, inputClass, Loading, PageHeader } from '../components/ui';
import { usePlants } from '../lib/queries';
import { AlarmViews } from './PlantAlarms';

/** Alarms across every plant you can see. */
export function Alarms() {
  const plants = usePlants();
  const [plant, setPlant] = useState('');

  if (plants.isPending) return <Loading />;
  if (plants.error) return <ErrorNote error={plants.error} />;
  const tz = new Map(plants.data.map((p) => [p.slug, p.timezone]));

  return (
    <>
      <PageHeader
        title="Alarms"
        subtitle="Times in each plant's time zone"
        actions={
          plants.data.length > 1 && (
            <select className={cx(inputClass, 'w-auto')} value={plant} onChange={(e) => setPlant(e.target.value)} aria-label="Plant">
              <option value="">All plants</option>
              {plants.data.map((p) => <option key={p.id} value={p.slug}>{p.name}</option>)}
            </select>
          )
        }
      />
      <AlarmViews key={plant} plant={plant || undefined} timezone={(slug) => tz.get(slug) ?? 'Europe/Oslo'} />
    </>
  );
}
